export const RENTAL_INVENTORY = [
  {
    id: 'rolls-royce-dawn',
    name: 'Rolls-Royce Dawn',
    category: 'Luxury',
    color: 'Arctic White / Red Interior',
    description:
      'Ultra-luxury convertible with coach doors, a handcrafted interior, and effortless presence. The ultimate choice for weddings, red-carpet arrivals, and executive chauffeur service.',
    highlights: ['Convertible', 'Coach Doors', 'Chauffeur Available'],
    images: [
      {
        src: '/images/rentals/rolls-royce-dawn/exterior.jpg',
        alt: 'Rolls-Royce Dawn with coach door open and red interior',
      },
      {
        src: '/images/rentals/rolls-royce-dawn/side.jpg',
        alt: 'Rolls-Royce Dawn side profile in white',
      },
      {
        src: '/images/rentals/rolls-royce-dawn/rear.jpg',
        alt: 'Rolls-Royce Dawn rear three-quarter view',
      },
      {
        src: '/images/rentals/rolls-royce-dawn/interior-seats.jpg',
        alt: 'Rolls-Royce Dawn red leather interior seats',
      },
      {
        src: '/images/rentals/rolls-royce-dawn/interior-dashboard.jpg',
        alt: 'Rolls-Royce Dawn dashboard and steering wheel',
      },
    ],
  },
  {
    id: 'rolls-royce-cullinan',
    name: 'Rolls-Royce Cullinan',
    category: 'Luxury',
    color: 'Arctic White / Black & White Interior',
    description:
      'The pinnacle of luxury SUVs — commanding presence, coach doors, and a refined cabin built for comfort. Ideal for weddings, corporate travel, and chauffeur-driven events across CT, MA, and NY.',
    highlights: ['Luxury SUV', 'Coach Doors', 'Chauffeur Available'],
    images: [
      {
        src: '/images/rentals/rolls-royce-cullinan/exterior.jpg',
        alt: 'Rolls-Royce Cullinan three-quarter front view in white',
      },
      {
        src: '/images/rentals/rolls-royce-cullinan/front.jpg',
        alt: 'Rolls-Royce Cullinan front grille and Spirit of Ecstasy',
      },
      {
        src: '/images/rentals/rolls-royce-cullinan/side.jpg',
        alt: 'Rolls-Royce Cullinan side profile with coach doors open',
      },
      {
        src: '/images/rentals/rolls-royce-cullinan/interior.jpg',
        alt: 'Rolls-Royce Cullinan black and white leather rear interior',
      },
    ],
  },
  {
    id: 'rolls-royce-cullinan-red',
    name: 'Rolls-Royce Cullinan',
    category: 'Luxury',
    color: 'Arctic White / Red Interior',
    description:
      'Statement luxury SUV with coach doors and a bold red leather cabin. Spacious, refined, and built for VIP arrivals — available with professional chauffeur service throughout CT, MA, and NY.',
    highlights: ['Luxury SUV', 'Red Interior', 'Chauffeur Available'],
    images: [
      {
        src: '/images/rentals/rolls-royce-cullinan-red/front.jpg',
        alt: 'Rolls-Royce Cullinan front view with red interior visible',
      },
      {
        src: '/images/rentals/rolls-royce-cullinan-red/exterior.jpg',
        alt: 'Rolls-Royce Cullinan with coach door open showing red interior',
      },
      {
        src: '/images/rentals/rolls-royce-cullinan-red/rear.jpg',
        alt: 'Rolls-Royce Cullinan rear three-quarter view',
      },
    ],
  },
  {
    id: 'ferrari-488-spider',
    name: 'Ferrari 488 Spider',
    category: 'Exotic',
    color: 'Giallo Modena',
    description:
      'Open-top Italian supercar with a retractable hardtop, mid-mounted V8, and head-turning presence. Perfect for weddings, photoshoots, and special occasions.',
    highlights: ['Convertible', 'V8 Twin-Turbo', 'Chauffeur Available'],
    images: [
      {
        src: '/images/rentals/ferrari-488-spider/exterior.jpg',
        alt: 'Ferrari 488 Spider exterior profile in yellow',
      },
      {
        src: '/images/rentals/ferrari-488-spider/front.jpg',
        alt: 'Ferrari 488 Spider front hood and badge',
      },
      {
        src: '/images/rentals/ferrari-488-spider/interior.jpg',
        alt: 'Ferrari 488 Spider interior with yellow stitching',
      },
      {
        src: '/images/rentals/ferrari-488-spider/wheel.jpg',
        alt: 'Ferrari 488 Spider wheel and yellow brake calipers',
      },
    ],
  },
];
